export default __webpack_public_path__ + "static/media/corebiz-footer.a31a2875.svg";